import { ChangeEventHandler, FC } from "react";

import "./SearchBox.css";
import {
  BORDER_INPUT_STYLES,
  FOCUS_INPUT_STYLES,
} from "../../../ui/layout/detailedPages/styles";
import { Styled } from "../../../ui/layout";

type SearchBoxProps = Styled & {
  placeholder: string;
  value: string;
  list?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

const INPUT_CLASSES = `search-box ${BORDER_INPUT_STYLES} ${FOCUS_INPUT_STYLES} flex w-full justify-center truncate rounded-md border-stone-200 bg-stone-50 py-2 pl-10 pr-3 leading-5 text-stone-900 placeholder-stone-500 dark:border-stone-600 dark:bg-stone-700 dark:text-white sm:text-sm lg:justify-start`;

export const SearchBox: FC<React.PropsWithChildren<SearchBoxProps>> = ({
  placeholder,
  list,
  onChange,
  value,
  className = "",
}) => {
  return (
    <input
      list={list ?? ""}
      id="search"
      className={`${INPUT_CLASSES} ${className}`}
      placeholder={placeholder}
      type="search"
      name="search"
      value={value}
      onChange={onChange}
    />
  );
};
